import { AutoFocusDirective } from './directives/auto-focus.directive';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedComponent } from './shared.component';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatRadioModule } from '@angular/material/radio';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatTooltipModule } from '@angular/material/tooltip';

// import {
//   MatToolbarModule, MatSidenavModule, MatButtonModule, MatIconModule, MatTableModule,
//   MatDialogModule, MatSlideToggleModule, MatSelectModule, MatInputModule, MatCheckboxModule,
//   MatNativeDateModule, MatDatepickerModule, MatSnackBarModule, MatProgressBarModule,
//   MatChipsModule, MatTooltipModule, MatRadioModule
// } from '@angular/material';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { CustomPaginationComponent } from './custom-pagination/custom-pagination.component';
import { IntlTelInputComponent } from './intl-tel-input/intl-tel-input.component';
import { PhoneNumberDirective } from './directives/phone-number.directive';
import { SpaceRemoverDirective } from './directives/space-remover.directive';
import { ShowErrorsComponent } from './show-errors/show-errors.component';
import { EmailValidatorDirective } from './custom-validator/email-validator';
import { SpecialCharacterRemoverDirective } from './directives/special-character-remover.directive';
import { FilterPipe } from './pipes/filter.pipe';
import { ValidatorTriggerDirective } from './directives/validator-trigger.directive';
import { ButtonSubmitDirective } from './directives/button-submit.directive';
import { FloatNumberDirective } from './directives/float-number.directive';
import { DateInputDisableDirective } from './directives/date-input-disable.directive';
import { FocusOnErrorDirective } from './directives/focus-on-error.directive';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

const MAT_MODULES = [
  MatRadioModule,
  MatToolbarModule,
  MatSidenavModule,
  MatButtonModule,
  MatIconModule,
  MatTableModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatSelectModule,
  MatInputModule,
  MatCheckboxModule,
  MatNativeDateModule,
  MatDatepickerModule,
  MatSnackBarModule,
  MatProgressBarModule,
  MatChipsModule,
  Ng2SearchPipeModule,
  MatTooltipModule,
  FormsModule,
  ReactiveFormsModule,
  NgxPaginationModule,
  NgbModule,
  MatTabsModule,
  MatSortModule
];
const pipes = [FilterPipe];
const components = [ShowErrorsComponent, CustomPaginationComponent,
  IntlTelInputComponent, EmailValidatorDirective];

const directives = [PhoneNumberDirective,
  AutoFocusDirective,
  DateInputDisableDirective, FocusOnErrorDirective,
  FloatNumberDirective,
  ValidatorTriggerDirective,
  ButtonSubmitDirective,
  SpaceRemoverDirective, SpecialCharacterRemoverDirective];

@NgModule({
  imports: [
    CommonModule,
    ...MAT_MODULES,

  ],
  exports: [
    CommonModule,
    ...MAT_MODULES,
    ...pipes,
    ...components,
    ...directives,
  ],
  declarations: [
    SharedComponent,
    ...pipes,
    ...components,
    ...directives
  ]
})

export class SharedModule { }
